import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Classes from './Classes'
import Inheritance from './Inheritance'
import Properties from './Properties'

class Class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      class: null,
      className: '',
      isLoading: true,
      parent: null
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    let className = ''
    const path = nextProps.location.pathname.replace(nextProps.match.path, '')

    if (nextContext && nextContext.data && nextContext.data.classes) {
      let currentClass = nextContext.data
      let parent = currentClass
      
      path.split('/').forEach((klass) => {
        if (klass !== '') {
          className = klass
          parent = currentClass
          currentClass = currentClass.classes[klass]
        }
      })

      this.setState({
        class: currentClass,
        className: className,
        isLoading: false,
        parent: parent
      })
    }
  }

  renderClass() {
    return (
      <div>
        <Inheritance class={this.state.class} className={this.state.className} parent={this.state.parent} />
        <Properties class={this.state.class} />
        <Classes class={this.state.class} />
      </div>
    )
  }

  renderLoading() {
    return (
      "Loading..."
    )
  }

  render() {
    const childs = this.state.isLoading ? this.renderLoading() : this.renderClass()

    return (
      <div>
        <h2>{this.state.className}</h2>
        {childs}
      </div>
    )
  }
}

Class.contextTypes = {
  data: PropTypes.object
}

export default Class



// WEBPACK FOOTER //
// ./src/Class.js